import React from 'react';

// A placeholder the agent leaves for text still to come ("<Direct SOP Reference will
// be added here>", "<Official program guidance link will be added soon>"), marked in
// bold on a yellow highlight wherever engine text shows, so it is not missed. Copies
// and downloads keep the text as stored.
export const PLACEHOLDER = /(<[A-Z][^<>\n]*>)/;
const PLACEHOLDER_STYLE = {
  backgroundColor: '#fff3b0', color: 'inherit', fontWeight: 700, padding: '0 2px', borderRadius: '2px',
};
export const Marked = ({ text }) => {
  if (typeof text !== 'string' || !PLACEHOLDER.test(text)) return text === undefined ? null : text;
  return text.split(PLACEHOLDER).map((piece, i) => (i % 2 === 1
    ? <mark key={i} data-testid="isfr-placeholder" style={PLACEHOLDER_STYLE}>{piece}</mark>
    : piece));
};
